import { Component } from '@angular/core';

@Component({
  selector: 'app-empty-page',
  standalone: true,
  imports: [],
  templateUrl: './empty-page.component.html',
  styleUrl: './empty-page.component.scss'
})
export class EmptyPageComponent {

}
